export const QUESTION =
  'Losing just 5-10% of your body weight can change the way you look and feel, and lower your risk of'

export const FIVE_PERCENTS = 5
